import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import isBetween from "dayjs/plugin/isBetween";
import isLeapYear from "dayjs/plugin/isLeapYear";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(duration);
dayjs.extend(isBetween);
dayjs.extend(isLeapYear);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(timezone);
dayjs.extend(utc);
export const dayjsDate = dayjs;
export const isValidDate = (value)=>{
    if (!value) return false;
    if (typeof value === 'string' && [
        'null',
        'undefined'
    ].includes(value.trim().toLowerCase())) {
        return false;
    }
    return dayjs(value).isValid();
};

//# sourceMappingURL=dayjsDate.js.map